import { isWeb } from '../src/utils/platformUtils'
import { PORTFOLIO_STORE_NAMES } from '../src/db/constants'
export const TRACKINGS = {
    TRACKINGS: 'trackings',
}

// ✅ MIGRADO: openDatabase() eliminado - ahora todos los métodos usan repositories TypeScript
// Ver: db-sqlite/repositories/tracking.repository.ts

class trackingServices {
    constructor() {
        // Todos los métodos son wrappers de tracking.repository
    }

    addTracking = async (interaction_id, type_interaction, table) => {
        // console.log('🚀 addTracking (wrapper)')
        
        try {
            // ✅ Usar la nueva implementación con manejo de errores
            const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
            return await trackingRepository.addTracking(interaction_id, type_interaction, table)
        } catch (error) {
            // ✅ Suprimir log de database lock - se maneja en withRetry
            const errorMessage = error?.message || String(error)
            if (!errorMessage.includes('database is locked')) {
                console.error('Error inesperado al guardar tracking:', errorMessage)
            }
            // No lanzar el error para que la app continúe funcionando
        }
    }

    getTrackings = async () => {
        // console.log('📊 getTrackings (wrapper)')
        
        // ✅ Usar la nueva implementación
        const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
        return await trackingRepository.getTrackings()
    }

    deleteTrackingsFromLocal = async () => {
        // console.log('🗑️ deleteTrackingsFromLocal (wrapper)')
        
        // ✅ Usar la nueva implementación
        const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
        return await trackingRepository.deleteAllTrackings()
    }

    deleteTrackingByIdFromLocal = async (trackingId) => {
        // console.log('🗑️ deleteTrackingByIdFromLocal (wrapper) =>', trackingId)
        
        try {
            // ✅ Usar la nueva implementación con manejo de errores
            const trackingRepository = await import('../db-sqlite/repositories/tracking.repository')
            return await trackingRepository.deleteTrackingById(trackingId)
        } catch (error) {
            // ✅ Suprimir log de database lock - se maneja en withRetry
            const errorMessage = error?.message || String(error)
            if (!errorMessage.includes('database is locked')) {
                console.error('Error inesperado al eliminar tracking:', errorMessage)
            }
            // No lanzar el error para que la app continúe funcionando
        }
    }
}

export const TrackingServices = new trackingServices()
